import React, { useState, useEffect } from "react";

import { useTitleFromComponent, useUrlState } from "../utils/hooks";

import { VsiBubble, VsiH4 } from "../styled/App.styled";
import { Button, ButtonGroup, Card, Input } from "reactstrap";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";
import { useVsiAppContext } from "../stores/VsiApp";
import VsiLabeledSelect from "./VsiLabeledSelect";
import { VsiSelectLabel } from "../styled/VsiLabeledSelect.styled";

const allUnits = [
  { value: "devices", label: "Devices" },
  { value: "pools", label: "Pools" },
  { value: "volumes", label: "Volumes" },
  { value: "luns", label: "LUNs" },
  { value: "shares", label: "Shares" },
  { value: "nodes", label: "Nodes" }
];

const allClients = [
  { name: 'Client 1'},
  { name: 'Client 2'},
  { name: 'Client 3'},
  { name: 'Client 4'},
  { name: 'Client 5'},
  { name: 'Client 6'},
];


function Sandbox({ title }) {
  useTitleFromComponent(`${title}`);
  const { theme } = useVsiAppContext();

  const [params, setParams] = useUrlState({
    unit: allUnits[0].value,
    client: "",
    metric: "Months",
    input: '',
  });

  const { client, metric, unit, input } = params;

  const [clientOptions, setClientOptions] = useState([]);
  const [isClientOptionsLoading, setIsClientOptionsLoading] = useState(true);

  const onUnitChange = ({ value }) => {
    setParams({
      unit: value
    });
  };

  const onClientChange = ({ value }) => {
    setParams({
      client: value
    });
  };

  const onForecastTypeClick = ({ target: { name } }) => {
    setParams({
      metric: name
    });
  }

  const onInputChange = ({ target: { value }}) => {
    setParams({
      input: value,
    });
  };

  const fauxNetworkRequest = async () => {
    setTimeout(() => {
      setClientOptions(allClients.map(({ name }) => ({
        value: name,
        label: name
      })));
      setIsClientOptionsLoading(false);
    }, 2500);
  };

  // modeling network request outside of use data with route
  useEffect(() => {
    fauxNetworkRequest();
  }, []);

  // result of network request.
  // "clientOptions" essentially serves like "recordset" of useDataWithRoute hook OR a separate useEffect -
  // - may be needed to watch "recordset" and create something like "clientOptions" (look at callback in "fauxNetworkRequest")
  useEffect(() => {
    if (clientOptions.length) {
      setParams({
        client: client || clientOptions[0].value
      });
    }
  }, [clientOptions, client]);

  return (
    <Card className={`report-card p-2 nav-card-${theme}`}>
      <VsiH4>Sandbox</VsiH4>
      <VsiBubble>
        <div className={"w-100 pb-2 d-flex"}>
          <VsiLabeledSelect options={allUnits}
                            label={"Static Dropdown (Unit)"}
                            onChange={onUnitChange}
                            minWidth={200}
                            defaultValue={allUnits.find(option => unit === option.value)} />
          <VsiLabeledSelect options={clientOptions}
                            label={"Async Dropdown (Client)"}
                            minWidth={200}
                            isDisabled={isClientOptionsLoading}
                            isLoading={isClientOptionsLoading}
                            onChange={onClientChange}
                            defaultValue={clientOptions.find(option => client === option.value)} />
          <div className={"me-2"}>
            <VsiSelectLabel>Button Option (Metric)</VsiSelectLabel>
            <div className="d-flex align-items-start justify-content-between">
              <ButtonGroup>
                <Button
                  name="Months"
                  onClick={onForecastTypeClick}
                  active={metric === "Months"}
                  disabled={metric === "Months"}
                >
                  Month
                </Button>
                <Button
                  name="Years"
                  onClick={onForecastTypeClick}
                  active={metric === "Years"}
                  disabled={metric === "Years"}
                >
                  Year
                </Button>
              </ButtonGroup>
            </div>
          </div>
          <div className={"me-2"}>
            <VsiSelectLabel>Input (Input)</VsiSelectLabel>
            <Input value={input} onChange={onInputChange}/>
          </div>
        </div>
      </VsiBubble>
    </Card>
  );
}

export default withErrorBoundary(Sandbox, GeneralErrorBoundary);
